module.exports = __webpack_public_path__ + "media/top/icon_question_left-5a1950d5.png";